<template>
    <div id="campaigns-summary" class="row">
        <div class="col-md-12">
            <div class="campaign-box">
                <div class="row">
                    <div class="col-md-12">
                        <h2 class="campaigns-details__adsets-title">
                            Overall Metrics
                            <info-tooltip
                                :inline="true"
                                text="This is a list of your campaigns and their metrics respective of the date range selected above. <br>Click on the campaign name to go to it's management page."
                            ></info-tooltip>
                        </h2>
                    </div>
                </div>

                <div class="row campaigns-details__adsets-summary">
                    <div class="col-md-7" v-if="canManageCampaigns()">
                        <a :href="createCampaignUrl" type="button" class="btn --green-light --white-font">Create a Campaign</a>
                    </div>
                    <div class="col-md-5" v-if="onlyStaffWithCampaigns()">
                        <form action="/tools/ad-set-trace/">
                            <div class="col-md-8">
                                <input
                                    name="adSetId"
                                    class="text-input"
                                    placeholder="Search by Ad Set Id"
                                />
                            </div>
                            <div class="col-md-4">
                                <button
                                    type="submit"
                                    class="btn --gray"
                                    :disabled="loading"
                                >
                                    Search
                                </button>
                            </div>
                        </form>
                    </div>
                </div>

                <div class="row campaigns-summary-title campaigns-dashboard">
                    <div class="col-xs-4" v-on:click="setSortBy('name')">
                        <div class="campaigns-summary-title__label">CAMPAIGNS</div>

                        <div class="campaigns-summary-title__icon" v-cloak>
                            <i class="material-icons" v-show="showSortBy('name', 'desc')">arrow_drop_up</i>
                            <i class="material-icons" v-show="showSortBy('name', 'asc')">arrow_drop_down</i>
                        </div>
                    </div>
                    <div class="col-xs-2 --blue" v-on:click="setSortBy('is_active')">
                        <div class="campaigns-summary-title__label">STATUS</div>

                        <div class="campaigns-summary-title__icon" v-cloak>
                            <i class="material-icons" v-show="showSortBy('status', 'desc')">arrow_drop_up</i>
                            <i class="material-icons" v-show="showSortBy('status', 'asc')">arrow_drop_down</i>
                        </div>
                    </div>
                    <div class="col-xs-2 --blue" v-on:click="setSortBy('click_count')">
                        <div class="campaigns-summary-title__label">EVENTS</div>

                        <div class="campaigns-summary-title__icon" v-cloak>
                            <i class="material-icons" v-show="showSortBy('click_count', 'desc')">arrow_drop_up</i>
                            <i class="material-icons" v-show="showSortBy('click_count', 'asc')">arrow_drop_down</i>
                        </div>
                    </div>
                    <div class="col-xs-2 --blue" v-on:click="setSortBy('daily_spend')">
                        <div class="campaigns-summary-title__label">TODAY'S SPEND</div>

                        <div class="campaigns-summary-title__icon" v-cloak>
                            <i class="material-icons" v-show="showSortBy('daily_spend', 'desc')">arrow_drop_up</i>
                            <i class="material-icons" v-show="showSortBy('daily_spend', 'asc')">arrow_drop_down</i>
                        </div>
                    </div>
                    <div class="col-xs-2 --blue" v-on:click="setSortBy('cost')">
                        <div class="campaigns-summary-title__label">AMOUNT SPENT</div>

                        <div class="campaigns-summary-title__icon" v-cloak>
                            <i class="material-icons" v-show="showSortBy('cost', 'desc')">arrow_drop_up</i>
                            <i class="material-icons" v-show="showSortBy('cost', 'asc')">arrow_drop_down</i>
                        </div>
                    </div>
                </div>

                <div v-for="campaign in sortedCampaigns" :key="campaign.id" class="row campaigns-summary-row" v-cloak>
                    <campaign-dashboard-row :campaign="campaign"
                                            :refreshingCampaignStats="refreshingCampaignStats"
                                            :loading="loading">
                    </campaign-dashboard-row>
                </div>

                <div class="row campaigns-summary-none" v-show="campaigns.length == 0" v-cloak>
                    <div class="col-md-12 text-center">
                        Your account currently has no campaigns.<br>
                        <a :href="createCampaignUrl" class="btn --green-light --white-font">Let's get started</a>
                    </div>
                </div>

                <disclaimer class="m-t-lg"></disclaimer>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['loading', 'refreshingCampaignStats', 'campaigns', 'createCampaignUrl'],

    data() {
        return {
            sortBy: 'is_active',
            orderBy: 'desc'
        }
    },

    computed: {
        sortedCampaigns() {
            return _.orderBy(this.campaigns, [this.sortBy, 'name'], [this.orderBy]);
        }
    },

    methods: {
        setSortBy(value) {
            this.sortBy = value;
            this.orderBy = this.orderBy === 'asc' ? 'desc' : 'asc';
        },

        showSortBy(sort, order) {
            return this.sortBy === sort && this.orderBy === order;
        }
    }
}
</script>
